import { render } from "./Knowledge.vue?vue&type=template&id=267142ea&scoped=true"
import script from "./Knowledge.vue?vue&type=script&lang=js"
export * from "./Knowledge.vue?vue&type=script&lang=js"

import "./Knowledge.vue?vue&type=style&index=0&id=267142ea&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-267142ea"]])

export default __exports__